import axios from 'axios';
import { CreatePreBooking } from '../models/preBookingModel';

const loadAbort = () => {
  return new AbortController();
};

export const createPreBookingEndpoint = (
  payload: CreatePreBooking,
  token: string,
) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: 'post',
        url: `${urlService}/pre-sales/v1/admin/pre-booking`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        data: JSON.stringify(payload),
      }),
    controller,
  };
};
